/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom'
import { connect } from "react-redux";
import styles from './CartDropdown.module.css';
import {
  getOrderCartItems,
  getRedeemableLoyaltyFields,
  hasOrderCartItems,
} from './cartDropdownHelpers';
import * as orderRepo from "../../shared/repos/graphql/order";
import * as orderActions from "../../redux/actions/order";
import * as elementsActions from "../../redux/actions/elements";
// eslint-disable-next-line import/no-cycle
import { getTotalPrice } from "../../shared/utilities/renderings";
import { orderMethods } from "../../shared/constants/order";
import { checkoutOrderMinAmount, getCartSubtotal, getLoyaltyDiscountAmount } from "../../shared/utilities/orders";
import { isCartOrder } from "../../shared/utilities/cartOrder";
import Loader from "../Loader/Loader";
import { defaultCurrency } from "../../shared/constants/currency";
import endpoints from "../../shared/constants/endpoints";
import { routeCountryPath } from "../../shared/utilities/common";
import { PUNCHH_TYPE } from "../../shared/constants/loyaltyType";
import amplitudeAnalytics from "../../shared/utilities/amplitude";

const AMPLITUDE_CART_PAGE_NAME = "Cart";

const clearDarkIcon = require("./imgs/clear-dark-icon.svg");
const plusIcon = require("./imgs/dark-plus.svg");
const minusIcon = require("./imgs/dark-minus.svg");
const trashIcon = require("./imgs/trash.svg");
const arrowIcon = require("./imgs/back-icon.svg");

export class CartDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderLoading: false,
      errorMessage: null,
    };
    this.dropdownRef = createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getOrder();
  }

  componentDidUpdate(prevProps) {
    const { order } = this.props;
    const {  orderLoading } = this.state;
    if (prevProps.order !== order && !orderLoading) {
      this.getOrder();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { toggleCartMenu } = this.props;
    if (event.target.closest("#cart-container")) {
        return;
    }
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      toggleCartMenu(false);
    }
  };

  toggleDropdown = () => {
    const { toggleCartMenu } = this.props;
    toggleCartMenu();
  };

  getOrder = () => {
    const { userCartId, order } = this.props;
    if (!userCartId || order) return this.setOrder(order);
    return this.fetchOrder();
  };

  fetchOrder = async () => {
    const { userCartId } = this.props;
    try {

      this.setState({ orderLoading: true, errorMessage: null });
      const response = await orderRepo.getOrder(userCartId);
      this.setOrder(response.data.order);
    } catch (e) {
      this.setState({ errorMessage: e.graphQLErrors?.[0]?.message || 'Something went wrong!' });
    } finally {
      this.setState({ orderLoading: false });
    }
  }

  setOrder = (order) => {
    if (!order) return;
    const { orderUpdated } = this.props;
    this.setState({ orderLoading: false });
    orderUpdated(order);
  };

  getProductOptions = (data) => {
    if (!data.productOptions || data.productOptions.length === 0) {
      return [];
    }
    
    const result = [];
    data.productOptions.forEach(option => {
      // Validate quantity is a positive integer
      const quantity = parseInt(option.quantity, 10);
      if (quantity && Number.isInteger(quantity) && quantity > 0) {
        const idx = result.findIndex(item => item.groupOptionId === option.groupOptionId.toString());
        if (idx !== -1) {
          result[idx].productIds.push(...Array(quantity).fill(option.options.id));
        } else {
          result.push({ groupOptionId: option.groupOptionId.toString(), productIds: Array(quantity).fill(option.options.id) });
        }
      }
    });

    return result;
  };

  updateQuantity = async (item, newQuantity) => {
    this.setState({ orderLoading: true, errorMessage: null });
    const { userCartId, order } = this.props;

    const orderRedeemable = order?.orderRedeemables?.find(p => {
      return p.order_product_id === item.id
    });

    const productOptions = this.getProductOptions(item);

    const { redemptionGroup, externalId } = getRedeemableLoyaltyFields(orderRedeemable);

    try {
      this.setState({ orderLoading: true, errorMessage: null });

      const product = item?.product;
      if (product?.title != null && product?.id != null) {
        if (newQuantity === 0) {
          amplitudeAnalytics.trackRemoveItem({
            productName: product.title,
            productId: product.id,
            pageName: AMPLITUDE_CART_PAGE_NAME,
          });
        } else if (newQuantity !== item.quantity) {
          amplitudeAnalytics.trackModifyItemQuantity({
            productName: product.title,
            productId: product.id,
            pageName: AMPLITUDE_CART_PAGE_NAME,
            increaseOrDecrease: newQuantity > item.quantity ? "Increase" : "Decrease",
          });
        }
      }

      const action = newQuantity === 0 
        ? orderRepo.removeProducts(userCartId, parseInt(item.id, 10)) 
        : orderRepo.addUpdateOrderProduct(userCartId, {
          orderProductId: parseInt(item.id, 10),
          product: item.product.id,
          productOptions,
          price: item.price,
          quantity: newQuantity,
          redeemableId: redemptionGroup === PUNCHH_TYPE.REDEEMABLE_FULL ? externalId : null, 
          dealId: redemptionGroup === PUNCHH_TYPE.DEALS ? externalId : null,
        });
    
      await action;
      this.fetchOrder();
    } catch (e) {
      this.setState({ errorMessage: e.graphQLErrors?.[0]?.message || 'Something went wrong!',  orderLoading: false });
    }
  };

  goToCheckout = () => {
    const { history, userCartId, userOrderMethod, order, currency, toggleCartMenu } = this.props;
    const cartItems = getOrderCartItems(order);
    if (cartItems.length > 0) {
      if (userOrderMethod === orderMethods.delivery) {
        const cartIconLink = endpoints.checkoutOrderPage.replace(':id', userCartId);
        const totalPrice = getCartSubtotal(cartItems);
        const loyaltyDiscountAmount = getLoyaltyDiscountAmount(order);
        if ((totalPrice - loyaltyDiscountAmount) < order.shippingMethodMinAmount) {
          checkoutOrderMinAmount(order.shippingMethodMinAmount, currency.symbol);
        } else {
          history.push(routeCountryPath(cartIconLink));
        }
      } else {
        history.push(routeCountryPath(endpoints.checkoutOrderPage.replace(':id', userCartId)))
      }
      toggleCartMenu();
    }
  }

  goToPdpPage = (item) => {
      const { history, toggleCartMenu} = this.props;
      const {hasAssortments, options, id} = item;
      const isBox = hasAssortments;
      const isCustom = !isBox && (options && options.length > 0);
      let path;
      if (isBox) {
          path = `/products/box/${id}`;
      } else if (isCustom) {
          path = `/products/customize/${id}`;
      } else {
          path = `/products/single/${id}`;
      }
      path += '?isUpsale=true';
      toggleCartMenu();
      return history.push(routeCountryPath(path));
  }

  renderErrorMessage() {
    const { errorMessage } = this.state;
    if (!errorMessage) {
      return null;
    }
    return (
      <p className="text-red-800 transition-opacity duration-1000 ease-out opacity-100">
        {errorMessage}
      </p>
    );
  }

  renderCartItems() {
    const { order } = this.props;
    if (!hasOrderCartItems(order)) {
      return <p>No items in your cart</p>;
    }
    return (
      <ul className="my-2">
        {this.renderOrderItem(order)}
      </ul>
    );
  }

  renderOrderItem = (order) => {
    const cartItems = getOrderCartItems(order);
    if (cartItems.length === 0) return null;

    return cartItems.map((item) => {
      if (!item.product) return null;

      const orderRedeemable = order.orderRedeemables?.find(p => p.order_product_id === item.id);
      const productOptionsPrice = item.productOptions?.reduce((acc, option) => acc + (option.optionPrice * option.quantity || 0), 0) || 0;
      const amount = orderRedeemable ? item.price : (getTotalPrice(item) * item.quantity) - productOptionsPrice;

      return (
        <li key={item.id} className="flex items-center justify-between py-2 border-b border-dashed">
          <div className='w-[80px] mr-[10px]'>
            <img src={item.product.productImageSmall} alt={item.product.title} className="object-contain" />
          </div>
          <div className="cart-product-info flex-1 break-words">
            <span className="bold text-base">{item.product.title}</span>
            <ul className="other-products">
              <li className="text-darkElevationPrimary text-sm mb-1">
                {item.quantity} 
                <span>&#8226;</span> 
                {amount.toFixed(2)}
              </li>
              {item.productOptions?.map((option) => (
                <li key={option.id} className="text-darkElevationPrimary text-sm opacity-75 mb-1">
                  {`${option.quantity} ${option.title}`}
                </li>
              ))}
            </ul>
          </div>
          <div className="cart-product-action flex items-center gap-2 p-1 border rounded-lg h-8">
            <img
              src={item.quantity > 1 ? minusIcon : trashIcon}
              alt="remove item"
              className="w-3 h-3 object-contain cursor-pointer"
              onClick={() => this.updateQuantity(item, item.quantity - 1)}
            />
            <div className="quantity">{item.quantity}</div>
            <img
              src={plusIcon}
              alt="add item"
              data-testid="add-item-button"
              className="w-3 h-3 object-contain cursor-pointer"
              onClick={() => this.updateQuantity(item, item.quantity + 1)}
            />
          </div>
        </li>
      );
    });
  };

  renderUpSellProducts = () => {
    const { order, currency } = this.props;
    if (!order?.upsellProducts || order.upsellProducts.length === 0) return null;
    return (
      <>
        <h4 className="font-bold text-sm">Complement your cart</h4>
        <ul className="flex gap-4 mb-2 flex-wrap my-4 pb-4 border-b-2 border-dashed">
          {
            order.upsellProducts.slice(0, 2).map((item)=>{
              return (
                <li className="flex flex-col cursor-pointer w-[120px] p-[10px]" key={item.id} onClick={() => this.goToPdpPage(item)}>
                  <div className="item-image  w-[100px] h-[100px] relative mb-3">
                    <img src={item.productImageSmall} alt={item.title} className="object-contain" />
                    <div className="w-[30px] h-[30px] flex items-center justify-center absolute bottom-0 right-[-10px] bg-light border border-mainDark rounded-full">
                      <img src={arrowIcon} alt="" className="h-[15px] width-[15px] object-contain rotate-180" />
                    </div>
                  </div>
                  <div className="item-details text-sm text-darkElevationPrimary text-center break-words">
                    <span className="">{item.title}</span> 
                    <br />
                    <span className="opacity-75">{`${currency.symbol}${item?.price?.toFixed(2)}`}</span>
                  </div>
                </li>
            )
            })
          }
        </ul>
      </>
    )
  };

  renderCheckoutButton() {
    const { currency, order, userOrderMethod } = this.props;
    const cartItems = getOrderCartItems(order);
    const loyaltyDiscountAmount = getLoyaltyDiscountAmount(order);
    const subTotal = getCartSubtotal(cartItems);
    const minAmount = order?.shippingMethodMinAmount;
    const isMinAmountMatched = cartItems.length === 0 || userOrderMethod !== orderMethods.delivery || (subTotal - loyaltyDiscountAmount) >= minAmount;

    return (
      <button
        type="button"
        onClick={this.goToCheckout}
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && this.goToCheckout()}
        className="w-full mt-2 bg-pink-500 text-white py-2 rounded-lg hover:bg-pink-600"
        disabled={!isMinAmountMatched}
      >
        {isMinAmountMatched ? "Checkout" : `${currency.symbol}${minAmount?.toFixed(2)} Delivery Minimum`}
      </button>
    );
  }

  renderSubTotal() {
    const { currency, order } = this.props;
    const cartItems = getOrderCartItems(order);
    const loyaltyDiscountAmount = getLoyaltyDiscountAmount(order);
    const subtotalDisplay = `${currency.symbol}${getCartSubtotal(cartItems).toFixed(2)}`;

    return loyaltyDiscountAmount > 0 ? (
      <div>
        <div className="flex justify-between font-bold py-2">
          <span>Sub Total:</span>
          <span>{subtotalDisplay}</span>
        </div>
        <div className="flex justify-between font-bold py-2">
          <span>Reward Redemption:</span>
          <span>{`-${currency.symbol}${loyaltyDiscountAmount.toFixed(2)}`}</span>
        </div>
      </div>
    ) : (
      <div className="flex justify-between font-bold py-2">
        <span>Sub Total:</span>
        <span>{subtotalDisplay}</span>
      </div>
    );
  }

  renderContent() {
    const { orderLoading } = this.state;
    const { order } = this.props;
    if (orderLoading) {
      return <Loader height={40} />;
    }
    return (
      <>
        {this.renderCartItems()}
        {hasOrderCartItems(order) && (
          <>
            {this.renderUpSellProducts()}
            {this.renderSubTotal()}
            {this.renderCheckoutButton()}
          </>
        )}
      </>
    );
  }

  render() {
    const {showCartMenu, shouldNotDisplayIntroBanner, contentCards} = this.props;
    if (!showCartMenu) {
      return null;
    }

    return (
      <div className={`${styles.cardDropdown} ${shouldNotDisplayIntroBanner || !contentCards ? styles.headerHasRibbon : ""} fixed w-[100%] sm:absolute 2xl:transform text-dark sm:w-[340px] zIndex border-mainDark shadow-md`} ref={this.dropdownRef}>
        <div className="relative bg-light shadow-lg rounded-lg px-4 py-6 max-h-[80vh] overflow-y-auto">
          <span onClick={this.toggleDropdown} className="closeIcon absolute right-0 top-0 p-2 cursor-pointer">
            <img src={clearDarkIcon} alt="" className="w-5 h-5 object-contain" />
          </span>
          <h4 className="font-bold text-sm">Cart</h4>
          {this.renderErrorMessage()}
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

CartDropdown.propTypes = {
  currency: PropTypes.objectOf(PropTypes.string),
  userOrderMethod: PropTypes.string,
  userCartId: PropTypes.string,
  showCartMenu: PropTypes.bool,
  shouldNotDisplayIntroBanner: PropTypes.bool,
  contentCards: PropTypes.string,
  order: PropTypes.shape(),
  orderUpdated: PropTypes.func,
  toggleCartMenu: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
};

CartDropdown.defaultProps = {
  currency: defaultCurrency,
  userOrderMethod: null,
  userCartId: null,
  order: null,
  showCartMenu: false,
  shouldNotDisplayIntroBanner: false,
  contentCards: null,
  orderUpdated: () => null,
  toggleCartMenu: () => null,
};

export const mapStateToProps = ({ user, currency, order, elements, braze }) => ({
  userCartId: user.userCartId,
  currency: currency.currency,
  userOrderMethod: user.userOrderMethod,
  showCartMenu: elements.showCartMenu,
  contentCards: braze.contentCards,
  order: isCartOrder(order, user.userCartId) ? order : null,
});

export const mapDispatchToProps = dispatch => ({
  orderUpdated: (value) => dispatch(orderActions.orderUpdated(value)),
  toggleCartMenu: (value) => dispatch(elementsActions.toggleCartMenu(value))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CartDropdown));